import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_teacher_appreciation: FaireThemeEntity = {
  token: "discovery_theme_teacher-appreciation",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Teacher Appreciation Gifts",
  description: "Meaningful gifts educators will treasure",
  bgColor: "#F5D8D4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
